import { Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { FileUpload } from "@mui/icons-material";
import FinanceClientsDataGrid from "./FinanceClientsDataGrid";
import { FullPagePaperLayout } from "pages/Layouts/FullPagePaperLayout";
import { PageActions, PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export function FinanceClients() {
  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs links={[{ label: "Finance" }]} />
      <PageTitle>Clients</PageTitle>
      <PageSubtitle>View all the companies that work with Revivn, their locations and contacts.</PageSubtitle>

      <PageActions>
        <Button
          component={RouterLink}
          variant="contained"
          to="/finance/clients/airbase-vendor-list-upload"
          startIcon={<FileUpload />}
        >
          Upload Airbase Vendor List
        </Button>
      </PageActions>

      <FinanceClientsDataGrid />
    </FullPagePaperLayout>
  );
}
